import type { ReactNode } from "react";

interface PageHeaderProps {
  title: ReactNode;
  actions?: ReactNode;
}

/**
 * Full-width portal-style title bar shown above a page's content.
 * Matches the green "Homepage" banner pattern from the portal reference.
 */
export function PageHeader({ title, actions }: PageHeaderProps) {
  return (
    <div className="page-header">
      <div className="page-header-inner">
        <h1>{title}</h1>
        {actions && <div className="page-header-actions">{actions}</div>}
      </div>
    </div>
  );
}
